module.exports = __webpack_public_path__ + "static/media/linkedin.5cc7e878.svg";